import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import FeaturedProducts from "./components/FeaturedProducts";
import EditorBanner from "./components/EditorBanner";
import TrustStrip from "./components/TrustStrip";
import StoryBlock from "./components/StoryBlock";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

export default function Home() {
  const [activeCategoryId, setActiveCategoryId] = useState<number | null>(null);
  const [activeCategoryName, setActiveCategoryName] = useState<string | null>(null);

  const handleSelectCategory = (id: number | null, name: string | null) => {
    setActiveCategoryId(id);
    setActiveCategoryName(name);
  };

  const handleClearFilter = () => {
    setActiveCategoryId(null);
    setActiveCategoryName(null);
  };

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Categories activeId={activeCategoryId} onSelect={handleSelectCategory} />
        <Hero />
        <FeaturedProducts
          categoryId={activeCategoryId}
          categoryName={activeCategoryName}
          onClearFilter={handleClearFilter}
        />
        <EditorBanner />
        <TrustStrip />
        <StoryBlock />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}